"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GA4Service {
    constructor(gtmService) {
        this.triggerBeginCheckoutEvent = (ecommerce) => this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'begin_checkout',
        });
        this.triggerRemoveFromCartEvent = (ecommerce) => this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'remove_from_cart',
        });
        this.gtmService = gtmService;
    }
    triggerAddPaymentInfoEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'add_payment_info',
        });
    }
    triggerAddShippingInfoEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'add_shipping_info',
        });
    }
    triggerAddToCartEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'add_to_cart',
        });
    }
    triggerLoginEvent(event) {
        return this.gtmService.triggerGenericEvent(Object.assign(Object.assign({}, event), { event: 'login' }));
    }
    triggerPurchaseEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'purchase',
        });
    }
    triggerSelectItemEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'select_item',
        });
    }
    triggerSelectPromotionEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'select_promotion',
        });
    }
    triggerSignUpEvent(event) {
        return this.gtmService.triggerGenericEvent(Object.assign(Object.assign({}, event), { event: 'sign_up' }));
    }
    triggerTutorialBeginEvent() {
        return this.gtmService.triggerGenericEvent({
            event: 'tutorial_begin',
        });
    }
    triggerTutorialCompleteEvent() {
        return this.gtmService.triggerGenericEvent({
            event: 'tutorial_complete',
        });
    }
    triggerViewCartEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'view_cart',
        });
    }
    triggerViewItemEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'view_item',
        });
    }
    triggerViewItemListEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'view_item_list',
        });
    }
    triggerViewPromotionEvent(ecommerce) {
        return this.gtmService.triggerECommerceEvent({
            ecommerce,
            event: 'view_promotion',
        });
    }
}
exports.default = GA4Service;
//# sourceMappingURL=ga4.service.js.map